import React, { useEffect } from "react";
import "../../Informations/Information.css";
import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

const NILSupportServicesAndFees = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className="page-main-container-aboutus">
        <div className="business-price-numbs">
          <div className="nill-img-text-hone"></div>

          <div>
            <h2 className="htwo-heading-aboutus">
              NIL Support Services | NIL-Collab.com
            </h2>
            <p className="text-aboutus">
              Navigating Name, Image, and Likeness (NIL) opportunities can be
              complex. NIL-Collab provides comprehensive support to
              student-athletes, helping them maximize their NIL potential while
              remaining fully compliant with NCAA and state regulations.
              Professional services are available to protect athletes,
              facilitate successful partnerships, and promote responsible NIL
              activity.
            </p>
          </div>
        </div>

        <div className="program-benefits-aboutus">
          <h3>NIL Support Services</h3>
          <p className="text-aboutus">
            NIL-Collab offers a range of professional services to support
            student-athletes, available <strong>if requested:</strong>
          </p>
          <ul className="nil-support-services-added">
            <li>
              <h3>Contract Review & Guidance</h3>
              <p className="text-aboutus">
                Review of NIL agreements to ensure fair terms, protect athlete
                rights, and identify potential conflicts. Assistance is
                available to help athletes secure optimal arrangements.
              </p>
            </li>
            <li>
              <h3>Compliance Monitoring</h3>
              <p className="text-aboutus">
                Guidance to ensure NIL activities adhere to NCAA, conference,
                and state regulations. Support is available to help athletes
                navigate evolving rules and policies.
              </p>
            </li>
            <li>
              {" "}
              <h3>Financial Literacy Education</h3>
              <p className="text-aboutus">
                Workshops and consultations on budgeting, tax considerations,
                and responsible money management, provided if requested.
              </p>
            </li>
            <li>
              <h3>Brand Building & Marketing Support</h3>
              <p className="text-aboutus">
                Assistance with personal brand strategy, identifying
                opportunities, and developing marketing approaches, available
                upon request.
              </p>
            </li>
            <li>
              <h3>Tax Reporting Assistance</h3>
              <p className="text-aboutus">
                Guidance on proper reporting for NIL income is available if
                requested to help maintain compliance with tax laws.
              </p>
            </li>
            <li>
              <h3>Educational Resources</h3>
              <p className="text-aboutus">
                Access to guides, FAQs, and updates on NIL regulations is
                provided for athletes seeking additional information.
              </p>
            </li>
          </ul>
        </div>

        <div className="program-benefits-aboutus">
          <h3>NIL Service Fee – 12.5%</h3>
          <p className="text-aboutus">
            A 12.5% NIL Service Fee applies to all NIL agreements facilitated
            through NIL-Collab.com. This is a flat fee that covers marketplace
            platform services, compliance, and administrative expenses.
          </p>

          <h3>Example</h3>
          <p className="text-aboutus">
            If an athlete secures an NIL agreement valued at $10,000, the NIL
            Service Fee would be $1,250 (12.5%).
          </p>

          <h3>Payment Terms</h3>
          <p className="text-aboutus">
            The flat fee is processed securely through the platform and is
            applied when the athlete receives payment from the sponsoring brand
            or entity.
          </p>

          <h3>Important Disclaimer</h3>
          <p className="text-aboutus">
            The 12.5% NIL Service Fee covers costs associated with the
            marketplace platform and related service expenses. However, it does
            not include professional services or any support-related services.
            This fee is not compensation to the athlete for the use of their NIL
            and has no impact on athletic participation. NIL-Collab operates
            independently and maintains full compliance with NCAA, conference,
            and state regulations.
          </p>
        </div>

        <div className="program-benefits-aboutus">
          <h3>Transparency & Contact</h3>
          <p className="text-aboutus">
            Questions about NIL Support Services or fees can be directed to:
            <br />
            <strong>Email:</strong>{" "}
            <a href="mailto:Pau.Coates@NIL-Collab.com">
              Pau.Coates@NIL-Collab.com
            </a>
          </p>

          <h3>Resources</h3>
          <p className="text-aboutus">
            <a
              href="https://ncaa.org/sports/nil"
              target="_blank"
              rel="noreferrer"
            >
              Link to NCAA NIL Guidelines
            </a>
          </p>
        </div>

        <div className="program-benefits-aboutus">
          <h3>FAQ</h3>
          <h3>What is the NIL Service Fee?</h3>
          <p className="text-aboutus">
            It is a professional services fee covering contract review,
            compliance monitoring, financial education, brand guidance, and
            related support <strong> if requested.</strong>
          </p>

          <h3>Why is this fee charged?</h3>
          <p className="text-aboutus">
            It ensures athletes have access to expert guidance and resources to
            navigate NIL opportunities responsibly and within regulations.
          </p>

          <h3>Is this fee payment to the athlete?</h3>
          <p className="text-aboutus">
            No. The fee covers services provided by NIL-Collab if requested and
            is not compensation for the athlete’s name, image, or likeness.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NILSupportServicesAndFees;
